<template>
    <v-dialog v-model="dialog" persistent max-width="400px">
        <v-card>
            <v-card-title>
                <span class="headline">Nahrát vstupenky</span>
            </v-card-title>
            <v-card-text>
                <v-form v-model="form.valid">
                    <v-select
                            :items="events"
                            item-text="name"
                            item-value="id"
                            v-model="form.event_id"
                            :rules="formRules.event_id"
                            label="Událost *"
                            required
                    ></v-select>

                    <div class="upload-btn-wrapper">
                        <v-btn block>Nahrát soubor</v-btn>
                        <input type="file" name="myfile" @change="upload" />
                    </div>

                    <v-alert v-if="csv.length && csv[0].length !== 17" class="mt-3" type="error">
                        Chyba souboru, musí mít 16 sloupců
                    </v-alert>

                    <v-alert v-if="csv.length && csv[0].length === 17" class="mt-3" type="success">
                        Soubor v pořádku. Řádek: {{csv.length}}, Bloků: {{blocks}}
                    </v-alert>
                </v-form>
            </v-card-text>
            <v-progress-linear v-if="progress" v-model="progressValue"></v-progress-linear>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text
                       @click="dialog = false"
                        :disabled="progress">
                    Zavřít
                </v-btn>

                <v-btn color="primary"
                       text @click="processForm"
                       :disabled="!form.valid || csv.length===0 || csv[0].length !== 17 || progress"
                >
                    Nahrát
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { parse } from 'csv-parse/sync'

    export default {
        data: () => ({
            dialog: false,
            progress: false,
            progressValue: 0,

            uploadOptions: {
                url: '/upload',
                paramName: 'file'
            },
            csv: [],
            form: {
                event_id: 0,
                // block_id: 0,
                valid: false
            },
            formRules: {
                event_id: [
                    v => v > 0 || 'Vyberte událost'
                ],
            }
        }),

        computed: {
            events () {
                return this.$store.state.event.list
            },
            // blocks () {
            //     const event = this.$store.state.events.find(event => event.id === this.form.event_id)
            //     return event ? event.blocks : []
            // },
            blocks () {
                return [...new Set(this.csv.map(item => {
                    const priceName = item[2].trim()
                    const ticketsetName = item[6].trim()
                    return `${ticketsetName}-${priceName}`
                }))].length
            }
        },

        methods: {
            show () {
                this.$store.dispatch('event/list')
                this.csv = []
                this.dialog = true
            },

            upload () {
                const files = event.target.files; // FileList object
                for (var i = 0; i < files.length; i++) {
                    const f = files[i]

                    if (!f.type.match('text/csv')) {
                        // console.log('CHYBA SOUBORU');
                    }

                    const reader = new FileReader()
                    reader.onload = (() => {
                        return e => {
                            const data = e.target.result
                            const ret = parse(data, {
                                skip_empty_lines: true,
                                delimiter: ',',
                                quote: '"'
                            })
                            // remove header
                            this.csv = ret.slice(1)
                        }
                    })(f)
                    reader.readAsText(f)
                }
            },

            async processForm () {
                this.progress = true
                this.progressValue = 0

                for (let pos=0; pos < this.csv.length; pos += 100) {
                    const block = this.csv.slice(pos, pos + 100)

                    await this.$store.dispatch('ticket/upload', {
                        eventId: parseInt(this.form.event_id),
                        ticketsJson: JSON.stringify(block)
                    })

                    this.progressValue = (pos / this.csv.length) * 100
                }

                // this.$store.dispatch('ticketsAll')
                this.$emit('complete')
                this.dialog = false
                this.progress = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        /*display: inline-block;*/

        input[type=file] {
            font-size: 70px;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>